import { render, staticRenderFns } from "./DevicesManagementList.vue?vue&type=template&id=2253d558&scoped=true&"
import script from "./DevicesManagementList.vue?vue&type=script&lang=js&"
export * from "./DevicesManagementList.vue?vue&type=script&lang=js&"
import style0 from "./DevicesManagementList.vue?vue&type=style&index=0&id=2253d558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2253d558",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VSelect,VTextField})
